"use strict";

function templateLight(g) {
  function init() {
    calculHeightIframe();
    window.onresize = calculHeightIframe;
  }

  function calculHeightIframe() {
    const iFrame = document.querySelector(".model-tpl-light iframe");
    const footer = document.querySelector(".footer");
    const footerHeight = footer.offsetHeight;

    // hauteur de l'iFrame : 100% de la hauteur de l'écran - la hauteur du footer
    iFrame.style.height = document.documentElement.offsetHeight - footerHeight - 5 + "px";
  }

  init();
}
